import DirectionsIcon from "./DirectionsIcon";

// When we add more arrows, change this to named exports
export default DirectionsIcon;
